import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'agentReview',
    inject: ['$eventBus'],
    props: {
        reviews: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data(){
        return {
            reviewsData: [],
            evaluatingReview: {},
            reviewPage: 1,
            fetchingReviews: false,
        };
    },
    computed:{
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dap', ['dap']),
    },
    methods: {
        ...mapActions('dap', ['voteReview', 'fetchReviews']),
        likeReview: function (review) {
            this.voteReview({
                reviewId: review._id,
                usefulFlag: 1
            }).then(e=>{
                this.$eventBus.$emit('eventbus-context-update');
                review.like = !review.like;
                if(review.like){
                    if(review.dislike){
                        review.dislike = false;
                        review.downVotes--;
                    }
                    review.upVotes++;
                }else{
                    review.upVotes--;
                }
            });
        },
        dislikeReview: function (review) {
            this.voteReview({
                reviewId: review._id,
                usefulFlag: 0
            }).then(e=>{
                this.$eventBus.$emit('eventbus-context-update');
                review.dislike = !review.dislike;
                if(review.dislike){
                    if(review.like){
                        review.like = false;
                        review.upVotes--;
                    }
                    review.downVotes++;
                }else{
                    review.downVotes--;
                }
            });
        },
        writeComment: function (review) {
            this.$eventBus.$emit('eventbus-agent-openreport', {data: review});
        },
        evaluateReview(review, evaluateReview) {
            if (this.evaluatingReview[review._id]) {
                return false;
            }
            this.evaluatingReview[review._id] = true;
            this.voteReview({
                reviewId: review._id,
                spamStatus: review.isSpam,
                evaluateReview
            }).then(e=>{
                this.evaluatingReview[review._id] = false;
                if (!(e instanceof Error)) {
                    this.$eventBus.$emit('eventbus-context-update');
                    review.isSpam = !review.isSpam;
                }
            });
        },
        fetchMoreReviews() {
            this.fetchingReviews = true;
            this.fetchReviews({
                agentId: this.dap.agentId,
                page: this.reviewPage + 1,
            }).then(result => {
                console.log(result);
                this.fetchingReviews = false;
                if (result && Array.isArray(result.data) && result.data.length) {
                    this.reviewsData = this.reviewsData.concat(result.data);
                    this.reviewPage++;
                }
            });
        },

    },
    mounted(){
        if (this.reviews && this.reviews.length) {
            const userId = this.glb.user ? this.glb.user.id : '';
            this.reviewsData = this.reviews.map(function (review) {
                const vote = review.reviewHelpful && review.reviewHelpful[userId];
                return {
                    ...review,
                    downVotes: review.reviewHelpful ? review.reviewHelpful.downVotes || 0 : 0,
                    upVotes: review.reviewHelpful ? review.reviewHelpful.upVotes || 0 : 0,
                    dislike: vote && vote.isHelpful === false,
                    like: vote && vote.isHelpful === true,
                };
            });
        }
    }
};